import GasCalculator from './GasCalculator.svelte';
import fragments from '../fragments.json';

const components = {
  'gas-calculator': GasCalculator,
}

const devContainer = document.querySelector('#dev_container');

fragments.forEach((f) => {
  if (devContainer) {
    const c = document.createElement('div');
    c.id = f.containerId;
    if (f.class) c.classList.add('tslr-block-' + f.class);
    devContainer.appendChild(c)
  }

  const t = document.querySelector('#' + f.containerId);
  if (t) new components[f.name]({
    target: t,
    hydrate: true,
    intro: true
  });

});
